import React, { useState, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ChangeUserPassword } from '../../store/UserSlice';

export default function ChangePassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const [userPayload, setUserPayload] = useState({
    newPassword: '',
    password: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({
    newPassword: '',
    confirmPassword: '',
  });

  const handleButtonClick = async (e: FormEvent) => {
    e.preventDefault();

    if (userPayload.newPassword !== userPayload.confirmPassword && userPayload.confirmPassword) {
      setErrors({
        ...errors,
        confirmPassword: 'Passwords do not match',
      });
      return;
    }   

    try {
      const result = await dispatch(ChangeUserPassword(userPayload));
      
    } catch (error: any) {
      toast.error(error.response?.data?.error?.message || 'Password change failed. Please try again.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUserPayload({
      ...userPayload,
      [name]: value,
    });

    // Clear errors when user starts typing
    setErrors({
      ...errors,
      [name]: '',
    });
  };
  

  return (
    <div className="w-full lg:w-1/2 p-8">
      <form onSubmit={handleButtonClick}>
        <div className="max-w-2xl m-auto">
          <div className="pt-4 w-full relative">
            <label htmlFor="password" className="block pb-2 text-[#263238] font-[18px] font-gilroy-medium">
              Current Password
            </label>
            <input
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4"
              name="password"
              type='password'
              value={userPayload.password}
              placeholder="Enter your current password"
              minLength={8}
              id="password"
              onChange={(e) => handleChange(e)}
            />
             
          </div>
          <div className="pt-4 lg:pt-8 w-full relative">
            <label htmlFor="newPassword" className="block pb-2 text-[#263238] font-[18px] font-gilroy-medium">
              New Password
            </label>    
            <input
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4"
              name="newPassword"
              type='password'
              value={userPayload.newPassword}
              placeholder="Enter your new password"
              minLength={8}
              id="newPassword"
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div className="pt-4 lg:pt-8 w-full relative">
            <label htmlFor="confirmPassword" className="block pb-2 text-[#263238] font-[18px] font-gilroy-medium">
              Confirm Password
            </label>
            <input
              className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4"
              name="confirmPassword"
              type='password'
              value={userPayload.confirmPassword}
              placeholder="Enter your confirm password"
              minLength={8}
              id="confirmPassword"
              onChange={(e) => handleChange(e)}
            />
            {errors.confirmPassword && <p className="text-red-500 text-sm">{errors.confirmPassword}</p>}
          </div>
          <button
            type="submit"
            className="bg-[#037897] text-white font-semibold float-left w-60 mt-8 py-2 px-4 mb-8 rounded-md"
          >
            Change Password
          </button>
        </div>
      </form>
    </div>
  );
}
